import React from "react"
import { isDefined } from "utils/validation"
import { useAlert } from "hooks/useAlert"
//import { isWebAssemblySupported } from "utils/functions"
import { useTranslation } from "react-i18next"
import { useModal } from "hooks/useModal"

import "./ScanOcode.scoped.scss"

const userMediaConstraints = {
    video: { facingMode: "environment" },
    audio: false
}

const ScanOcode = ({ onSuccess, onError, className }) => {
    const [, setOcode] = React.useState()
    // Camera management
    const [isMediaSupport, setIsMediaSupport] = React.useState(false)
    const [displayCamera, setDisplayCamera] = React.useState(false)

    const canvasRef = React.useRef(null)
    const videoRef = React.useRef(null)
    const timerRef = React.useRef(null)

    const { alert } = useAlert()
    const { t } = useTranslation()

    React.useEffect(() => {
        navigator.getUserMedia = navigator.getUserMedia ||
                                 navigator.webkitGetUserMedia ||
                                 navigator.mozGetUserMedia ||
                                 isDefined(navigator.mediaDevices) ? navigator.mediaDevices.getUserMedia : null ||
                                 null

        if (navigator.getUserMedia === null || window.isWebAssemblySupport() === false) {
            setIsMediaSupport(false)
        }
        else {
            // listener when the o°code, is detected
            window.addEventListener("ocode", process, false)
            // start camera
            setIsMediaSupport(true)
            cameraStart()
        }

        // Clean on unmount
        return () => {
            if (isDefined(window.localstream)) {
                window.localstream.getTracks()[0].stop()
            }
        }
    }, []) // eslint-disable-line


    const onPlay = () => {
        const ratio = videoRef.current.videoWidth / videoRef.current.videoHeight
        const canvasWidth = 1200
        const canvasHeight = parseInt(canvasWidth / ratio)
        canvasRef.current.style.width = `${canvasWidth}px`
        canvasRef.current.style.height = `${canvasHeight}px`
        canvasRef.current.width = canvasWidth
        canvasRef.current.height = canvasHeight
        if (isMediaSupport) cameraDraw()
    }

      const cameraStart = () => {
        setDisplayCamera(true)
        navigator.mediaDevices
            .getUserMedia(userMediaConstraints)
            .then((stream) => {
                // track = stream.getTracks()[0]
                videoRef.current.srcObject = stream
                window.localstream = stream
            })
            .catch((error) => {
                alert("error", t("scan_camera_error", { ns: "bike" }))
                console.error("Something is broken like permission not authorized", error)
                setDisplayCamera(false)
                setIsMediaSupport(false)
                if (onError) onError()
            })
    }

    const cameraDraw = () => {
        if (videoRef.current) {
            if (videoRef.current.paused || videoRef.current.ended) return

            const ctx = canvasRef.current.getContext("2d")
            ctx.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height)
            const imageData = ctx.getImageData(0, 0, canvasRef.current.width, canvasRef.current.height)
            const buffer = new ArrayBuffer(imageData.data.length)
            const uint8 = new Uint8Array(buffer)
            uint8.set(imageData.data)

            try {
                window.detectOcode(uint8, imageData.width, imageData.height)
            } catch (e) {
                console.log("Issue when trying to detect Ocode", e)
            }

            timerRef.current = setTimeout(cameraDraw, 0)
        }

    }

    const process = (event) => {
        // ocode has been detected
        clearTimeout(timerRef.current)
        timerRef.current = null
        window.removeEventListener("ocode", process, false)
        setDisplayCamera(false)

        if (isDefined(window.localstream)) {
            window.localstream.getTracks()[0].stop()
        }

        setOcode(event.detail)

        if (onSuccess) onSuccess({ ocode: event.detail })
    }

    /*React.useEffect(() => {
      if (onSuccess) onSuccess({ ocode })
    })*/

    return (
        <>
            <div className={"u-relative " + (className ? className : "")} style={{ minHeight: "50vh" }}>
                {displayCamera &&
                    <div className="c-scan">
                        <video
                            ref={videoRef}
                            className="c-scan__video"
                            playsInline
                            autoPlay
                            onPlay={onPlay}>
                        </video>

                        <canvas
                            ref={canvasRef}
                            className="c-scan__canvas">
                        </canvas>

                        <div className="c-scan__mire">
                            <div id="mireoverlay" className="c-scan__mire-overlay"></div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

const ModalScanCode = ({ title, callback }) => {
    const { hideModal } = useModal()
    const { t } = useTranslation()

    const validate = (response) => {
        hideModal()
        callback(response)
    }
    return (
        <div className="p-12">
            <h2 className="c-h2 text-primary font-bold text-center my-7">{title}</h2>
            <ScanOcode
                onSuccess={validate}
                onError={hideModal}
                className="mb-7"
            />
            <div className="flex justify-center flex-col">
                <button
                    type="button"
                    className="c-btn c-btn--white-bordered px-7 mb-5"
                    onClick={hideModal}
                >
                    {t("global.cancel")}
                </button>
            </div>
        </div>
    )
}

export { ScanOcode as default, ModalScanCode }
